import { ApiHosts, handleResponseOld, makeGet } from '@/redux/api/helpers';

export type ResolveBrowseUrlPayload = {
    /** When set, client should 301 to this path (relative, includes leading slash). */
    redirectPath?: string;
    /** Canonical browse path for meta and comparisons. */
    canonicalPath?: string;
    /** Base category ids for categoryweb `ids` parameter. */
    categoryIds?: number[];
    /** Pre-resolved facet option ids by search facet id (e.g. creator → ['18755']). */
    facetOptionsByFacetId?: Record<string, string[]>;
    /** Indexability / threshold (when provided by API). */
    seoIndexable?: boolean;
    /** Optional robots meta content e.g. `noindex, follow`. */
    robots?: string;
};

export type ResolveBrowseUrlApiResponse = {
    error: boolean;
    payload?: ResolveBrowseUrlPayload;
};

type ResolveBrowseUrlParams = {
    deployment: string;
    pathname: string;
    search?: string;
};

/**
 * Calls category-api to normalize/resolve a browse URL (canonical redirects, slug resolution).
 * Fails soft: callers should fall back to client-side resolution when `error` is true.
 */
export const fetchResolveBrowseUrl = ({
    deployment,
    pathname,
    search = '',
}: ResolveBrowseUrlParams): Promise<ResolveBrowseUrlApiResponse> => {
    return new Promise((resolve, reject) => {
        const request = makeGet({
            apiPath: 'resolve-browse-url',
            deployment,
            path: ApiHosts.Category,
        });
        request.query({
            pathname,
            ...(search && { search: search.startsWith('?') ? search.slice(1) : search }),
        });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response, success404: true }));
    });
};
